import {
    IProps,
} from './types';

import classNames from 'classnames';
import {
    QRCodeCanvas,
    QRCodeSVG,
} from 'qrcode.react';
import React, {
    FC,
    useRef,
} from 'react';

import {
    BaseButton,
} from 'components/buttons';

import downloadImage from './media/download.svg';

import styles from './QR.module.scss';

const DOWNLOAD_SIZE = 240;
const MARGIN_SIZE = 2;
const DOWNLOAD_FILE_NAME = 'qr.png';

const QR: FC<IProps> = (props) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const onClickDownload = () => {
        const canvas = canvasRef.current;

        if (!canvas) {
            return;
        }

        const link = document.createElement('a');

        link.href = canvas.toDataURL('image/png');
        link.download = DOWNLOAD_FILE_NAME;
        link.click();
    };

    return (
        <div className={classNames(styles.qr, props.className)}>
            <div className={styles.code}>
                <QRCodeSVG
                    className={styles.image}
                    value={props.text}
                    marginSize={MARGIN_SIZE}
                />
                <QRCodeCanvas
                    ref={canvasRef}
                    className={styles.hiddenCanvas}
                    value={props.text}
                    size={DOWNLOAD_SIZE}
                    marginSize={MARGIN_SIZE}
                />
            </div>
            <BaseButton
                className={styles.download}
                text={'Download QR'}
                iconLeft={
                    <img
                        className={styles.downloadImage}
                        src={downloadImage}
                        alt={'Download'}
                    />
                }
                onClick={onClickDownload}
            />
        </div>
    );
};

export default QR;
